// extracted by mini-css-extract-plugin
export var dropdown = "_ut-0";
export var imageWrapper = "_ut-3";
export var itemNameContainer = "_ut-1";
export var productImage = "_ut-2";
export var spinnerWrapper = "_ut-4";